var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingValue,
          expression: "loadingValue",
        },
      ],
      staticClass: "yxtbiz-signup-config relative",
      style: { height: _vm.height },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.cfgs.title,
              expression: "cfgs.title",
            },
          ],
          staticClass: "fs14 h56 lh56 fw500 pl26 b3b1 border-box",
        },
        [_vm._v("\n    " + _vm._s(_vm.language()[_vm.cfgs.title]) + "\n  ")]
      ),
      _c(
        "div",
        {
          class:
            "absolute left0 right0 " +
            (_vm.cfgs.title ? "top56 pt24" : "top0") +
            " pt24 bottom56  o-auto",
        },
        [
          _c(
            "yxt-form",
            {
              ref: "form",
              attrs: {
                "label-position": "right",
                "label-width": "134px",
                model: _vm.data,
                rules: _vm.rules,
                "validate-on-rule-change": false,
              },
            },
            [
              _vm._l(_vm.cfgs.forms, function (form, fIndex) {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: form.title,
                          expression: "form.title",
                        },
                      ],
                      key: fIndex,
                      class:
                        "relative fs16 fw500 mb24 ml40 sign" +
                        (fIndex !== 0 ? " mt30" : ""),
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.language()[form.title]) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._l(form.controls, function (control, cIndex) {
                    return [
                      _vm.isShow(control.show) && !_vm.isHide(control.hide)
                        ? [
                            _c(
                              "yxt-form-item",
                              {
                                key: fIndex + "" + cIndex,
                                class: control.form
                                  ? (control.key === "wheres" &&
                                      _vm.data["wheres"].length > 0) ||
                                    (control.key === "allows" &&
                                      _vm.data.allowOtherEnroll === 1) ||
                                    control.key === "needAudit" ||
                                    (control.key === "needAttach" &&
                                      _vm.data.needAttach === 1)
                                    ? "mb0"
                                    : "mb18"
                                  : "",
                                attrs: {
                                  "label-tooltip":
                                    _vm.language()[control.tooltip],
                                  label: _vm.language()[control.label],
                                  prop: control.key,
                                },
                              },
                              [
                                _c("controls", {
                                  attrs: {
                                    data: _vm.data,
                                    control: control,
                                    cfgs: _vm.cfgs,
                                  },
                                  on: { validateField: _vm.validateField },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      control.form
                        ? [
                            _vm._l(control.form, function (ctl, i) {
                              return [
                                ctl.key === "requireCount" &&
                                _vm.data["wheres"].length > 0
                                  ? [
                                      _c(
                                        "yxt-form-item",
                                        {
                                          key: fIndex + "" + cIndex + "" + i,
                                          staticClass: "mb8",
                                          attrs: {
                                            "label-tooltip":
                                              _vm.language()[ctl.tooltip],
                                            label: _vm.language()[ctl.label],
                                            "label-width":
                                              (ctl.label &&
                                                ctl.label !== " ") ||
                                              ctl.labelShow
                                                ? ctl.labelWidth || "210px"
                                                : "",
                                            prop: ctl.key,
                                          },
                                        },
                                        [
                                          _c("controls", {
                                            attrs: {
                                              disabled:
                                                _vm.data["wheres"].length === 1,
                                              data: _vm.data,
                                              control: ctl,
                                              cfgs: _vm.cfgs,
                                            },
                                            on: {
                                              validateField: _vm.validateField,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                ctl.key !== "requireCount" &&
                                _vm.isShow(ctl.show) &&
                                !_vm.isHide(ctl.hide)
                                  ? [
                                      _c(
                                        "yxt-form-item",
                                        {
                                          key: fIndex + "" + cIndex + "" + i,
                                          class:
                                            ctl.key === "concer" ||
                                            ctl.key === "conexams"
                                              ? "mb18 condition"
                                              : "mb18",
                                          attrs: {
                                            "label-tooltip":
                                              _vm.language()[ctl.tooltip],
                                            label: _vm.language()[ctl.label],
                                            "label-width":
                                              (ctl.label &&
                                                ctl.label !== " ") ||
                                              ctl.labelShow
                                                ? ctl.labelWidth || "210px"
                                                : "",
                                            prop: ctl.key,
                                          },
                                        },
                                        [
                                          _c("controls", {
                                            attrs: {
                                              data: _vm.data,
                                              control: ctl,
                                              cfgs: _vm.cfgs,
                                            },
                                            on: {
                                              validateField: _vm.validateField,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            }),
                          ]
                        : _vm._e(),
                    ]
                  }),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      !_vm.isHideBtn
        ? _c(
            "div",
            {
              staticClass:
                "absolute left0 right0 h56 lh56 bottom0 box-shadow-opts align-center",
            },
            [
              _c(
                "yxt-button",
                {
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.cancel.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.language().btn_cancel))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingSave },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.save.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.language().btn_save))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.language()[_vm.cfgs.drawer.title],
            "header-border": !!_vm.cfgs.drawer.title,
            "destroy-on-close": true,
            visible: _vm.cfgs.drawer.show,
            size: _vm.cfgs.drawer.size,
            "before-close": _vm.closeDrawer,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.cfgs.drawer, "show", $event)
            },
          },
        },
        [
          _vm.cfgs.drawer.name
            ? [
                _vm.cfgs.drawer.key === "projId"
                  ? [
                      _c(
                        _vm.cfgs.drawer.name,
                        _vm._b(
                          {
                            key: _vm.cfgs.drawer.name,
                            tag: "component",
                            attrs: { projId: _vm.cfgs.drawer.value },
                            on: { success: _vm.auditSuccess },
                          },
                          "component",
                          Object.assign({}, _vm.cfgs.drawer.props, {
                            tmplCode: this.data.auditTemplateCode,
                            dataPermissionCode: _vm.auditDataPermissionCode
                              ? _vm.auditDataPermissionCode
                              : _vm.cfgs.drawer.props.dataPermissionCode,
                            functionCode: _vm.functionCode
                              ? _vm.functionCode
                              : _vm.cfgs.drawer.props.functionCode,
                          }),
                          false
                        )
                      ),
                    ]
                  : _vm.cfgs.drawer.key === "personRange"
                  ? [
                      _c(
                        _vm.cfgs.drawer.name,
                        _vm._b(
                          {
                            key: _vm.cfgs.drawer.name,
                            tag: "component",
                            attrs: { personRange: _vm.cfgs.drawer.value },
                            on: {
                              "update:personRange": function ($event) {
                                return _vm.$set(
                                  _vm.cfgs.drawer,
                                  "value",
                                  $event
                                )
                              },
                              "update:person-range": function ($event) {
                                return _vm.$set(
                                  _vm.cfgs.drawer,
                                  "value",
                                  $event
                                )
                              },
                            },
                          },
                          "component",
                          Object.assign({}, _vm.cfgs.drawer.props, {
                            enableGroupCorp: _vm.enableGroupCorp,
                            visibleOrgSelector: _vm.visibleOrgSelector,
                            targetOrgId: _vm.targetOrgId,
                            visibleOrgIds: _vm.visibleOrgIds,
                            disabledOrgSelect: _vm.disabledOrgSelect,
                            dataPermissionCode:
                              _vm.dataPermissionCode &&
                              _vm.cfgs.drawer.props.hasOwnProperty(
                                "dataPermissionCode"
                              )
                                ? _vm.dataPermissionCode
                                : _vm.cfgs.drawer.props.dataPermissionCode,
                            functionCode:
                              _vm.functionCode &&
                              _vm.cfgs.drawer.props.hasOwnProperty(
                                "functionCode"
                              )
                                ? _vm.functionCode
                                : _vm.cfgs.drawer.props.functionCode,
                          }),
                          false
                        )
                      ),
                    ]
                  : _vm.cfgs.drawer.key === "surveies"
                  ? [
                      _c(
                        _vm.cfgs.drawer.name,
                        _vm._b(
                          {
                            key: _vm.cfgs.drawer.name,
                            tag: "component",
                            attrs: {
                              selected:
                                _vm.cfgs.drawer.value &&
                                _vm.cfgs.drawer.value.length
                                  ? _vm.cfgs.drawer.value[0].id
                                  : undefined,
                            },
                            on: { select: _vm.formSelect },
                          },
                          "component",
                          Object.assign({}, _vm.cfgs.drawer.props),
                          false
                        )
                      ),
                    ]
                  : [
                      _c(
                        _vm.cfgs.drawer.name,
                        _vm._b(
                          {
                            key: _vm.cfgs.drawer.name,
                            tag: "component",
                            model: {
                              value: _vm.cfgs.drawer.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.cfgs.drawer, "value", $$v)
                              },
                              expression: "cfgs.drawer.value",
                            },
                          },
                          "component",
                          Object.assign({}, _vm.cfgs.drawer.props, {
                            groupSelect: _vm.enableGroupCorp,
                            groupShared: _vm.groupShared,
                            orgFunctionCode: _vm.orgFunctionCode,
                            orgDataPermissionCode: _vm.orgDataPermissionCode,
                            dataPermissionCode:
                              _vm.dataPermissionCode &&
                              _vm.cfgs.drawer.props.hasOwnProperty(
                                "dataPermissionCode"
                              )
                                ? _vm.dataPermissionCode
                                : _vm.cfgs.drawer.props.dataPermissionCode,
                            functionCode:
                              _vm.functionCode &&
                              _vm.cfgs.drawer.props.hasOwnProperty(
                                "functionCode"
                              )
                                ? _vm.functionCode
                                : _vm.cfgs.drawer.props.functionCode,
                          }),
                          false
                        )
                      ),
                    ],
              ]
            : _vm._e(),
          _vm.cfgs.drawer.footer
            ? _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "yxt-button",
                    { attrs: { plain: "" }, on: { click: _vm.closeDrawer } },
                    [_vm._v(_vm._s(_vm.language().btn_cancel))]
                  ),
                  !_vm.cfgs.drawer.confirmButton
                    ? _c(
                        "yxt-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.confirmDrawer },
                        },
                        [_vm._v(_vm._s(_vm.language().btn_confirm))]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }